var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.isRenderComponent,{tag:"component",attrs:{"data":_vm.data,"id":_vm.data.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }